import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { observable } from 'mobx';
import { AppUI, DictionaryNavigation } from '@seedlang/state';
import { GraphOutlineIcon, FaqIcon } from '@seedlang/icons';
import WordNavigation from 'components/vocab/word_navigation';
import HeaderBar from 'components/header_bar';
import withRouteParams from 'utils/with_route_params';
import { Outlet, useNavigate } from 'react-router-dom';

const Content = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: ${props => props.isMobile ? 0 : '10px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props => props.padding};
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  width: 100%;
`;


@observer
class VocabHome extends React.Component {
  @observable.ref dictionaryNavigation;

  constructor(props) {
    super(props);
    this.resetDictionaryNavigation();
  }

  resetDictionaryNavigation = () => {
    this.dictionaryNavigation = new DictionaryNavigation(
      this.props.location?.state?.dictionaryNavigation || DictionaryNavigation.fromStore(AppUI.wordStore)
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.state !== this.props.location?.state || prevProps.params.wordId !== this.props.params.wordId) {
      this.resetDictionaryNavigation();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  navigateWord = async direction => {
    const navigation = this.dictionaryNavigation;
    const currentWordId = this.props.params.wordId;
    const wordId = await navigation.adjacent(currentWordId, direction);
    if (!this.unmounted && navigation === this.dictionaryNavigation && currentWordId === this.props.params.wordId && wordId) {
      AppUI.wordStore.setShowData(navigation.word(wordId));
      this.props.navigate(AppUI.routeStore.pathFor({name: 'vocab.word', params: {wordId}}), {
        state: {dictionaryNavigation: navigation.context},
      });
    }
  }

  componentDidMount() {
    AppUI.createEvent('vocab - view page');
  }

  renderWordNavigation = () => {
    const wordId = this.props.params.wordId;
    if (!wordId) { return null; }
    return (
      <WordNavigation
        loading={this.dictionaryNavigation.loading}
        canNavigate={direction => this.dictionaryNavigation.canNavigate(wordId, direction)}
        onNavigate={this.navigateWord}
      />
    );
  }

  render() {
    return (
      <Wrapper>
        <HeaderBar
          title={`${AppUI.targetLanguageName} VOCAB`}
          homeRoute='vocab.home'
          titleRoute='vocab.home'
          titleParams={{page: this.dictionaryNavigation.position(this.props.params.wordId)?.page || AppUI.wordStore.page || 1}}
          pageInfo={[
            {
              route: 'vocab.progress',
              current: 'Progress',
            },
          ]}
          icons={[
            {
              icon: <FaqIcon />,
              tooltipText: 'Help Center',
              iconRoute: 'faq_categories.show',
              iconParams: {faqCategoryId: 'b31dc1e8-07dd-4b39-936f-d5a3238a57d5'},
            },
            {
              icon: <GraphOutlineIcon />,
              tooltipText: 'View Progress',
              iconRoute: 'vocab.progress',
              breadcrumb: 'Progress',
            },
          ]}
        />
        {this.dictionaryNavigation.error && <div role='alert'>Couldn’t load more words. Please try again.</div>}
        <Content
          isMobile={AppUI.layout.isMobile}
        >
          {this.renderWordNavigation()}
          <Outlet />
        </Content>
      </Wrapper>
    );
  }
}

const VocabHomeWithParams = withRouteParams(ErrorBoundary(VocabHome));

export default function VocabHomeWithNavigation(props) {
  const navigate = useNavigate();
  return <VocabHomeWithParams {...props} navigate={navigate} />;
}
